export const translateRoleToSpanish = (role: string): string => {
  const roleMap: Record<string, string> = {
    super_admin: "Administrador",
    property_manager: "Administrador de Propiedad",
    property_owner: "Propietario",
    cleaning: "Limpieza",
    maintenance: "Mantenimiento",
    guest: "Huésped",
  };

  return roleMap[role] || role;
};